/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
/**

## Selector Control Content Section

**Contextual Component** This component is not intended to be used as a standalone. Checkout it's potential parent components for usage instead:
- [Selector Control](../../selector-control.html)

Selector Navigation Section is a simple yielded block component for use with the [selector-control](../../selector-control.html)
component. It determines whether or not it's contents should be visible by matching its `item` param to a list of
`activeItems` it is given. This component is tagless.

See [selector-control](../../selector-control.html)
for usage.

@param {string} [key] - (required) a unique identifier that matches this piece of content to its navigation item
*/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { assert } from '@ember/debug';
import { isPresent } from '@ember/utils';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: '',
  isActive: computed('currentItem', 'key', function () {
    return this.get('currentItem') === this.get('key');
  }),
  didReceiveAttrs() {
    this._super();
    assert('You must pass a `key` to {{selector-control/content/section}}', isPresent(this.get('key')));
  }
});